import * as React from 'react';
import { useQuery } from 'react-query';
import type {
  ScheduledTripTrackingReport as Report,
} from 'contracts/scheduled-reports';
import { downloadScheduledReport } from 'utils';
import { useFetchScheduledReports } from 'hooks/api/scheduled-reports';
import { Scaffold } from 'layouts';
import {
  TabbedNavigation,
} from 'pages/scheduled-reports/shared-components';
import { DataTableV2 } from 'components/ui/DataTableV2';

import { useTripReportColumns } from './hooks';

export const TripsTrackingReportsPage = () => {
  const { fetchScheduledReports } = useFetchScheduledReports<Report>();

  const columns = useTripReportColumns({
    onClickDownload: downloadScheduledReport,
  });

  const reportsQuery = useQuery({
    queryKey: ['fetch-trip-tracking-reports'],
    initialData: [],
    queryFn: () => fetchScheduledReports({
      type: 'trips',
    }),
  });

  return (
    <Scaffold>
      <TabbedNavigation />
      <div className={'flex flex-col gap-6'}>
        <DataTableV2
          columns={columns}
          data={reportsQuery?.data ?? []}
        />
      </div>
    </Scaffold>
  );
};